function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-339.000000, -95.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 61.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(341.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.269230769,
  y1: 0.269230769,
  x2: 6.73076923,
  y2: 6.73076923
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.269230769,
  y1: 6.73076923,
  x2: 6.73076923,
  y2: 0.269230769
}))))));

function SvgCloseCrossWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossWhite);
export default __webpack_public_path__ + "static/media/close-cross-white.f0dd9039.svg";
export { ForwardRef as ReactComponent };